import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BillPaymentStatusEnum } from '@zaoblako/shared/modules/document/enums/bill.payment.status.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BillPaymentStatusEnum} enumeration values */
export const BillPaymentStatusEnumI18n: EnumI18nInterface<BillPaymentStatusEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BillPaymentStatusEnum.NOT_PAID]: 'Не оплачен',
    [BillPaymentStatusEnum.PAID]: 'Оплачен',
    [BillPaymentStatusEnum.PARTIALLY_PAID]: 'Оплачен частично',
  },
  [I18nLocalesEnum.EN_US]: {
    [BillPaymentStatusEnum.NOT_PAID]: 'Not paid',
    [BillPaymentStatusEnum.PAID]: 'Paid',
    [BillPaymentStatusEnum.PARTIALLY_PAID]: 'Partially paid',
  },
};
